module.exports = __webpack_public_path__ + "dobroshrift.7bc5141495a3ad6ddae4.svg";